import { set } from 'lodash/fp';
import createReducer from '../../../helpers/createReducer';
import {
  createFetchManyHandler,
  createFetchOneHandler,
  createSaveHandler,
  createDeleteHandler
} from '../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../helpers/pagination';
import {
  fetchDownloadRequests,
  fetchDownloadRequest,
  createDownloadRequest,
  fetchDownloadRequestResult,
  deleteDownloadRequest
} from '../../sagas/routines';
import {
  setDownloadRequestsQuery,
  clearDownloadRequests,
  downloadRequestsOnChangePage
} from '../../actions/download-request';

const initialState = {
  all: {},
  query: {},
  resultById: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  savingError: null,
  fetchingError: null,
  fetchingResult: false,
  fetchedResult: false,
  fetchingResultError: null,
  deleting: false,
  deleted: false,
  deletingError: null,
  pagination: paginationState(),
  order: 'createdAt:desc'
};

const setDownloadRequestsQueryHandler = action => ({
  [action.toString()]: (state, { payload }) => set('query', payload, state)
});

const clearDownloadRequestHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const downloadRequestOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

export const createFetchResultHandler = routine => ({
  [routine.TRIGGER]: state => ({
    ...state,
    fetchingResult: true,
    fetchedResult: false
  }),
  [routine.SUCCESS]: (state, { payload: { id, response } }) =>
    set(`resultById.${id}`, response, state),
  [routine.FAILURE]: (state, { error }) =>
    set('fetchingResultError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetchingResult: false,
    fetchedResult: true
  })
});

export default createReducer(initialState, {
  ...setDownloadRequestsQueryHandler(setDownloadRequestsQuery),
  ...createFetchManyHandler(fetchDownloadRequests),
  ...createFetchOneHandler(fetchDownloadRequest),
  ...createSaveHandler(createDownloadRequest),
  ...createFetchResultHandler(fetchDownloadRequestResult),
  ...clearDownloadRequestHandler(clearDownloadRequests),
  ...createDeleteHandler(deleteDownloadRequest),
  ...downloadRequestOnChangePageHandler(downloadRequestsOnChangePage)
});
